import { useState } from "react";

interface UsePaginationProps {
  initialPageSize?: number;
  initialPage?: number;
}

interface UsePaginationReturn {
  pageSize: number;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  resetPagination: () => void;
}

/**
 * Custom hook to manage pagination state
 * @param initialPageSize Initial page size (default: 10)
 * @param initialPage Initial page (default: 1)
 * @returns Object containing pagination state and methods
 */
export function usePagination({
  initialPageSize = 10,
  initialPage = 1
}: UsePaginationProps = {}): UsePaginationReturn {
  const [pageSize, setPageSize] = useState<number>(initialPageSize);
  const [currentPage, setCurrentPage] = useState<number>(initialPage);

  // Reset pagination to initial values
  const resetPagination = () => {
    setPageSize(initialPageSize);
    setCurrentPage(initialPage);
  };

  return {
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
    resetPagination
  };
}
